import { BrowserModule } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, APP_ID, Inject } from '@angular/core';

import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import * as _ from 'lodash';


import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { NavComponent } from './nav/nav.component';
import { AppRoutingModule } from './/app-routing.module';
import { ShopService } from './shop.service';
import { InstaService } from './insta.service';
import { PostsService } from './posts.service';
import { PostComponent } from './post/post.component';
import { ProductComponent } from './product/product.component';
import { VideoComponent } from './video/video.component';
import { VideosComponent } from './videos/videos.component';
import { PostsComponent } from './posts/posts.component';
import { TeamComponent } from './team/team.component';
import { HistoryComponent } from './history/history.component';
import { ProductsComponent } from './products/products.component';
import { DudeComponent } from './dude/dude.component';
import { FooterComponent } from './footer/footer.component';
import { CartComponent } from './cart/cart.component';
import { Http, HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { NgxJsonLdModule } from 'ngx-json-ld';
import { HistoryPostComponent } from './history-post/history-post.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    NavComponent,
    PostComponent,
    ProductComponent,
    VideoComponent,
    VideosComponent,
    PostsComponent,
    TeamComponent,
    HistoryComponent,
    ProductsComponent,
    DudeComponent,
    FooterComponent,
    CartComponent,
    HistoryPostComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ngbender' }),
    BrowserModule,
    AppRoutingModule,
    HttpModule,
    HttpClientModule,
    NgbModule.forRoot(),
    FormsModule,
    InfiniteScrollModule,
    NgxJsonLdModule
  ],
  providers: [
    InstaService,
    PostsService,
    ShopService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(APP_ID) private appId: string) {
    const platform = isPlatformBrowser(platformId) ?
      'in the browser' : 'on the server';
    console.log(`Running ${platform} with appId=${appId}`);
  }
}




// WEBPACK FOOTER //
// /tmp/build_fdb7fa8d/src/app/app.module.ts